import Vue from "vue"
import VueI18n from "vue-i18n"
import logger from "@/utils/logger";
import ru from "./localization/messages.ru.json"
import en from "./localization/messages.en.json"
import pluralize from "./pluralize.ru";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "en",
  silentFallbackWarn: true,
  pluralizationRules: {
    ru: pluralize
  },
  messages: {
    ...ru,
    ...en
  }
});

export function setLocale(lang) {
  i18n.locale = lang;
}

export async function setLocaleAsync(lang) {
  try {
    const messages = await import(`./localization/messages.${lang}.json`);
    i18n.setLocaleMessage(lang, messages.default);
    i18n.locale = lang;
  } catch (e) {
    logger.error(e);
  }
}

export default i18n;
